<template>
  <div>
    <div>
      <img class="img" src="static/hsbank/img_banner_hs.png" />
    </div>
    <div>
      <b-container>
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-card
              no-body
              class="overflow-hidden mt-2"
              @click="showLimitTip()"
            >
              <b-row no-gutters>
                <b-col md="12" class="mx-auto">
                  <b-card-img
                    src="static/hsbank/img_apply_hs.png"
                    alt="Image"
                    class="rounded-0"
                  ></b-card-img>
                </b-col>
                <b-col md="12">
                  <b-card-body class="text-center">
                    <b-row>
                      <b-col cols="10" class="mx-auto">
                        <h6><b>申请徽宝成长卡定制卡面</b></h6>
                      </b-col>
                    </b-row>
                    <b-button variant="danger" class="btnClass">申请</b-button>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-card
              no-body
              class="overflow-hidden mt-2"
              @click="toQueryOrder()"
            >
              <b-row no-gutters>
                <b-col md="12" class="mx-auto">
                  <b-card-img
                    src="static/hsbank/img_query_hs.png"
                    alt="Image"
                    class="rounded-0"
                  ></b-card-img>
                </b-col>
                <b-col md="12">
                  <b-card-body class="text-center">
                    <b-row>
                      <b-col cols="10" class="mx-auto">
                        <h6><b>进度查询</b></h6>
                      </b-col>
                    </b-row>
                    <b-button variant="danger" class="btnClass">查询</b-button>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-modal ref="model_update" title="提示" ok-title="确定" ok-only centered>
      <p>
        系统升级中，申请徽宝成长卡定制卡面和进度查询功能暂不能使用。已申请的业务进度查询，请拨打电话：17756086603
        查询制卡进度。
      </p>
    </b-modal>
    <b-modal
      ref="model_limit_tip"
      title="提示"
      ok-title="确定"
      @ok="hande_limit_ok()"
      cancel-title="取消"
      centered
    >
      <p>
        申请徽宝成长卡定制卡面，<span class="limitTip"
          >仅面向16周岁以下儿童办理。</span
        >
      </p>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "Home_hs",
  data() {
    return {
      isUpdate: true,
      // isUpdate: false,
    };
  },
  created() {},
  mounted: function () {
    console.log("Home_hs mounted");
    this.$store.commit("hs/resetState");
    //初始入口 1 申请卡面，2 查询进度 -1默认值
    sessionStorage.setItem("entrance", -1);
    let storeStr = JSON.stringify(this.$store.state.hs);
    console.log("storeStr:" + storeStr);
    if (this.isUpdate) {
      this.showUpdateMsg();
    }
  },
  methods: {
    showLimitTip() {
      if (this.isUpdate) {
        return;
      }
      this.$refs["model_limit_tip"].show();
    },
    hande_limit_ok() {
      this.toApplyCard();
    },
    toApplyCard: function () {
      sessionStorage.setItem("entrance", 1);
      console.log(this.$store.state.hs);
      this.$router.push({
        name: "ApplyCard_hs",
      });
    },
    toQueryOrder: function () {
      if (this.isUpdate) {
        return;
      }
      sessionStorage.setItem("entrance", 2);
      console.log(this.$store.state.hs);
      this.$router.push({
        name: "QueryOrder_hs",
      });
    },
    showUpdateMsg: function () {
      this.$refs["model_update"].show();
    },
  },
};
</script>

<style scoped>
.img {
  width: 100vw;
}

.btnClass {
  font-size: 14px;
  padding-left: 32px;
  padding-right: 32px;
}
.limitTip {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/huishangbank/Home_hs.vue